import React, { useEffect, useState } from 'react'
import { Select } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { equals, map, isNil, isEmpty } from 'ramda'
import { useTranslation } from 'react-i18next'
import { getOptions, getUserValue } from '../utils'
import { fetchPepStatuses } from '../../api'
import { usePrevious } from '../../utils/hooks'

const ExternalSelectPoliticallyExposedDetails = ({ label, name, additionalInfo, showLabelAsPlaceholder, dependOnBooleanFldName }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [pepStatusesList, setPepStatusesList] = useState([])
  const [fullPepStatusesList, setFullPepStatusesList] = useState([])
  const [isValid, setIsValid] = useState(null)
  const [shouldPresetValue, setShouldPresetValue] = useState(true)
  const [isVisible, setIsVisible] = useState(!dependOnBooleanFldName)
  const [{ user, form, form: { accId } }, dispatch] = useStore()
  const dependOnBooleanFldValue = form[accId][dependOnBooleanFldName]
  const prevDependOnFieldValue = usePrevious(dependOnBooleanFldValue)
  const userValue = getUserValue(accId, user, name)
  const prevUserValue = usePrevious(userValue)

  useEffect(() => {
    fetchPepStatuses().then(
      /**
       * @param {OptionsInput[]} statuses
       */
      (statuses) => {
        setFullPepStatusesList(statuses)
        setPepStatusesList(getOptions(statuses))
      })
  }, [i18n.language])

  useEffect(() => {
    if (
      !dependOnBooleanFldName ||
      (prevDependOnFieldValue === dependOnBooleanFldValue && prevUserValue === userValue)
    ) return

    if (dependOnBooleanFldValue === 'Y') {
      if (userValue && shouldPresetValue) {
        presetValue(userValue)
        setIsVisible(true)
      } else {
        setIsVisible(true)
        dispatch({ type: 'addValidationFld', name })
        if (!isNil(value) && !isEmpty(value)) {
          presetValue(value)
        }
      }
    } else {
      dispatch({ type: 'removeValidationFld', name })
      dispatch({ type: 'removeFieldValue', name })
      setIsVisible(false)
    }
  }, [dependOnBooleanFldValue, userValue, fullPepStatusesList, name, i18n.language])

  /**
   * @param {string} value
   */
  const getSelectValue = (value) => (equals(value, t('generatedField.choose')) ? '' : value)

  const presetValue = (value) => {
    const stringValue = value.toString()
    setValue(stringValue)
    const isValid = stringValue.length > 0
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  const onChange = ({ target: { value, name } }) => {
    const selectedValue = getSelectValue(value)
    setValue(selectedValue)
    setIsValid(!!selectedValue.length)

    dispatch({
      type: 'setExtFieldValue',
      name,
      value: selectedValue
    })

    dispatch({
      type: 'setValidationFld',
      name,
      value: selectedValue.length > 0
    })
    setShouldPresetValue(false)
  }

  return isVisible ? (
    <Select
      value={value || ''}
      label={t(label)}
      placeholder={t('generatedField.choose')}
      options={pepStatusesList}
      onChange={onChange}
      name={name}
      key={name}
      error=''
      valid={isValid}
      info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
      showLabelAsPlaceholder={showLabelAsPlaceholder}
    />
  ) : null
}

const getExternalPoliticallyExposedDetailsFields = map(currencyField => {
  const { i18n, name, required, order, dependOnBooleanFldName } = currencyField
  return (
    <ExternalSelectPoliticallyExposedDetails
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      required={required}
      key={name}
      order={order}
      dependOnBooleanFldName={dependOnBooleanFldName}
    />
  )
})

export { ExternalSelectPoliticallyExposedDetails, getExternalPoliticallyExposedDetailsFields }
